import { RestoreOutlined } from "@mui/icons-material";
import {
    Box,
    Card,
    Chip,
    CircularProgress,
    TextField,
    Typography,
} from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import { theme } from "../../../Theme/theme";
import { POST } from "../../../Utilities/BaseService";

type Props = any;
const SingleRange = ({ data, updatedSettings, setUpdatedSettings }: Props) => {
    const [initialValue, setInitialValue] = useState<any>({
        key: "",
        label: "",
        value: "",
    });
    const [setting, setSetting] = useState<any>({
        key: "",
        label: "",
        value: "",
    });

    const queryClient = useQueryClient();

    const compareValues = (initialValue: any, finalValue: any) => {
        const initVal = initialValue.value;
        const finalVal = finalValue.value;

        let _result = initVal == finalVal;

        return _result;
    };

    const handleChange = (e: any) => {
        let value = e.target.value;

        const sett = {
            ...setting,
            value: parseInt(value),
        };
        setSetting(sett);

        const isSame = compareValues(initialValue, sett);

        if (!isSame) {
            setUpdatedSettings({
                ...updatedSettings,
                [data?.key]: sett.value,
            });
        }
    };

    useEffect(() => {
        if (data) {
            setInitialValue({
                key: data.key,
                label: data.label,
                value: data.value,
            });

            setSetting({
                key: data.key,
                label: data.label,
                value: data.value,
            });
        }
    }, [data]);

    const isGlobal = useMemo(() => {
        const regions = Object.fromEntries(
            Object.entries(setting).filter(
                ([k, v]) =>
                    k === "district" || k === "village" || k === "hamlet"
            )
        );

        if (regions.district) return false;

        return true;
    }, [setting.district, setting.village, setting.hamlet]);

    const restoreMut = useMutation(
        (sett: any) => POST("/settings/add-single", sett),
        {
            onSuccess(res) {
                window.location.reload();
            },
        }
    );

    return (
        <Card
            elevation={0}
            sx={{
                bgcolor: theme.palette.common.white,
                p: 2,
                mb: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            <Box display="flex" alignItems="center" gap={1}>
                <Typography display="flex" alignItems="center" gap={1}>
                    {data?.label}
                </Typography>

                {!data?.IsDefault && (
                    <Chip
                        label={
                            restoreMut.isLoading ? "Restoring..." : "Restore"
                        }
                        size="small"
                        color="info"
                        variant="outlined"
                        deleteIcon={
                            restoreMut.isLoading ? (
                                <CircularProgress size={15} />
                            ) : (
                                <RestoreOutlined />
                            )
                        }
                        onDelete={() =>
                            restoreMut.mutate({
                                id: data.id,
                                key: data.key,
                                isGlobal,
                            })
                        }
                    />
                )}
            </Box>

            <div>
                <TextField
                    name="value"
                    label="No. of Months"
                    value={setting.value}
                    size="small"
                    sx={{ mx: 1 }}
                    type="number"
                    onChange={handleChange}
                />
            </div>
        </Card>
    );
};

export default SingleRange;
